// All of these uuids shoud refer to the pages in en-default folder in Storyblok.
// When modifying please leave a comment next to the page if the page located in the different folder.

export const storyblokPageUuids = {
  airPassengerRights: "d62f4404-5bd7-45f3-bd61-737955d94823",
  affiliate: "3df81573-04ba-4526-b5bb-2abfa39d71d3",
  help: "7b08d591-4ab1-4c06-b410-f8e98ebdd558",
  privacy: "6ad4ed42-5715-49db-b214-e31a7989a610",
  terms: "963a9094-e2c0-45fe-abbb-9876ed013ddb",
  referralTerms: "363f8d82-5d4a-405b-b2b1-f40f34e37309",
  affiliateTerms: "00ab32ca-350d-4e2f-9aba-a54f2e1b753f",
  affiliatePrivacy: "bbf689bf-afb4-4b54-b2a9-9dfb2e6fac24",
  airhelpPlus: "c6c612bd-cdf1-4f8a-b085-074a37b8f299",
  airPayout: "6cde405c-8b26-48a1-bb54-115e7c75c472",
  airLuggage: "9a19d113-d368-4e83-ba25-ed0e81871ba4",
  helpAFriend: "5f046285-ce33-40fd-b6d0-e020e9f1af51",
  airhelpReviews: "48cd7326-2e30-466a-b677-7c765608425e",
  ourFees: "26f2770b-f63d-4a3f-afba-9e5a3858bdeb",
  aboutUs: "efb22c8d-a4de-4380-adc2-82982b5d5bcc",
  press: "c2866f8c-91c8-4a43-8bdd-2bbeee471940",
  legalPartners: "42967498-800e-427b-9350-68948e5b1b03",
  becomeAPartner: "81e3553e-f5b8-417d-9216-7d6ba2d97243",
  forAirlines: "396a0108-7dbc-4dd9-82e4-1e3b1a0d8d72",
  cookies: "75878017-dbb8-4b93-92f0-c73244607135",
  planYourTrip: "148eaafc-5432-4444-9ec3-d2fa9befb6fd",
  brazilianTerms: "2c57b916-059e-4ed1-8545-6a08524ab3e1",
  brazilianPriceList: "49975282-4b76-49ba-a551-4ba6df30708e",
  airhelpPlusTerms: "6963c94a-23bb-4231-bf5a-8f632c1d19dc",
  priceList: "21601f20-29ee-421c-a79a-ab2e1cadc06f",
  imprint: "49618fbb-54d1-404f-a020-eadb21d4803f",
  flightDelayCompensation: "b6a1fdb4-61fe-4f3c-b6ff-a53aa6e9e1c7",
  flightCancellationCompensation: "a2fc8989-db9b-403d-b910-f1984a29ff74",
  missedConnectionCompensation: "d275803a-65ff-4105-b6db-952cfbc6dbfd",
  overbooking: "e884c1ac-0eb5-4992-86d0-8064ceb5e5c6",
  deniedBoardingCompensation: "a04689cc-4b73-4b47-ab09-4c1b9de4a28c",
  delayedBaggageCompensation: "b80be452-586d-4f9f-a800-8daca9a567e6",
  coronavirus: "8c4b55ad-c40b-4ed0-b5bc-f39dfe1917a6",
  flightRefund: "f4938b15-7e33-44e6-a89a-9e82551cf356",
  airhelpScore: "3c09ca09-86b8-4011-ba39-2030c3b2ce8d",
  blog: "39a11ccd-f166-4d77-a72f-435024dcfaf3",
} as const;

export const storyblokOtaPageUuids = {
  otaPriceList: "d592ca75-3546-4fb2-a5f7-df57b0f5148c",
  otaTerms: "b070d209-e5ef-413b-9ee3-32a981c837ff",
  otaPrivacy: "7f3aa874-4064-47bd-955b-406d68f6586f",
  otaFaq: "5dd67fe2-e1c3-4cf0-a273-23e67c705f51",
  otaBrasilTerms: "e731d76b-5d12-436f-b6e8-9a57d8f3a9a2",
  otaBrasilPriceList: "8095fa97-20b1-4ae3-b3d5-cc449907e1c1",
  otaAirhelpPlusTerms: "45ff3216-37ce-48c8-a227-31763eafb410",
} as const;

export type StoryblokPageName = keyof typeof storyblokPageUuids;
export type StoryblokPageUuid = typeof storyblokPageUuids[StoryblokPageName];

export const STORYBLOK_PAGE_NAMES = Object.keys(storyblokPageUuids) as StoryblokPageName[];
